(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["deals-home"]) return;
  try {
    
  const toggleButtons = document.querySelectorAll('.deal-toggle');

  toggleButtons.forEach(button => {
    button.addEventListener('click', () => {
      const currentGroup = button.parentElement;
      const siblingGroup = currentGroup.nextElementSibling || currentGroup.previousElementSibling;

      // Toggle visibility by switching classes
      currentGroup.classList.toggle('deal-hidden');
      currentGroup.classList.toggle('deal-visible');
      siblingGroup.classList.toggle('deal-hidden');
      siblingGroup.classList.toggle('deal-visible');
    });
  });

  } catch(e) { console.error(e); }
})();
})();
